import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import WhySection from './components/WhySection';
import HowItWorks from './components/HowItWorks';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const comparisonItems = [
  {
    name: 'CSSBuy Spreadsheet',
    vs: 'Kakobuy Spreadsheet',
    advantage: 'szybsze aktualizacje, więcej kategorii',
  },
  {
    name: 'Superbuy Spreadsheet',
    vs: 'Kakobuy Spreadsheet',
    advantage: 'lepsza selekcja produktów, polska społeczność',
  },
  {
    name: 'Oopbuy Spreadsheet',
    vs: 'Kakobuy Spreadsheet',
    advantage: 'codzienne aktualizacje, sprawdzone linki',
  },
  {
    name: 'Sugargoo Spreadsheet',
    vs: 'Kakobuy Spreadsheet',
    advantage: 'przyjazny interfejs, wsparcie dla Polski',
  },
];

const latestArticles = [
  {
    title: 'Kompletny Poradnik Kakobuy Spreadsheet 2026',
    desc: 'Wszystko, co musisz wiedzieć o korzystaniu z arkusza – od podstaw po zaawansowane triki.',
    path: '/artykul/kakobuy-spreadsheet-poradnik-2026',
    img: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20desk%20setup%20with%20laptop%20displaying%20colorful%20spreadsheet%20data%20surrounded%20by%20carefully%20arranged%20fashion%20accessories%20soft%20natural%20daylight%20streaming%20through%20sheer%20curtains%20Scandinavian%20interior%20warm%20cream%20and%20beige%20palette%20editorial%20photography%20with%20gentle%20shadows%20and%20refined%20composition&width=600&height=400&seq=home-article-card-01&orientation=landscape',
    seq: 'home-art-1',
  },
  {
    title: 'Nike Kakobuy Spreadsheet – Linki do Butów i Odzieży',
    desc: 'Odkryj setki zweryfikowanych linków do Nike – od Dunk po Air Force 1 i Jordan.',
    path: '/artykul/nike-kakobuy-spreadsheet-2026',
    img: 'https://readdy.ai/api/search-image?query=Athletic%20lifestyle%20flat%20lay%20with%20vibrant%20multicolored%20Nike%20running%20shoes%20sports%20watch%20and%20workout%20gear%20on%20light%20grey%20textured%20surface%20dynamic%20morning%20light%20with%20crisp%20shadows%20energetic%20composition%20modern%20activewear%20photography%20style%20with%20subtle%20gradient%20background&width=600&height=400&seq=home-article-card-02&orientation=landscape',
    seq: 'home-art-2',
  },
  {
    title: 'Jordan Kakobuy Spreadsheet – Kultowe Modele Retro',
    desc: 'Air Jordan 1, 4, 11 i limitowane kolaboracje – wszystko w jednym arkuszu.',
    path: '/artykul/jordan-kakobuy-spreadsheet-2026',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20basketball%20aesthetic%20flat%20lay%20with%20classic%20Air%20Jordan%20sneakers%20in%20red%20black%20and%20white%20colorways%20on%20weathered%20hardwood%20court%20surface%20nostalgic%20golden%20hour%20backlight%20retro%20sports%20magazine%20style%20editorial%20product%20photography%20with%20rich%20warm%20tones%20and%20subtle%20film%20grain&width=600&height=400&seq=home-article-card-03&orientation=landscape',
    seq: 'home-art-3',
  },
  {
    title: 'Wysyłka Kakobuy do Polski – Poradnik',
    desc: 'Koszty, metody, cło – kompletny przewodnik po wysyłce z arkusza do Polski.',
    path: '/artykul/wysylka-kakobuy-spreadsheet-polska',
    img: 'https://readdy.ai/api/search-image?query=Shipping%20and%20ecommerce%20themed%20flat%20lay%20with%20cardboard%20boxes%20packing%20materials%20bubble%20wrap%20tape%20dispenser%20and%20fashion%20items%20on%20light%20wooden%20desk%20bright%20natural%20window%20light%20clean%20minimal%20composition%20warm%20neutral%20colors%20professional%20product%20photography%20with%20organized%20tidy%20arrangement&width=600&height=400&seq=home-article-card-04&orientation=landscape',
    seq: 'home-art-4',
  },
  {
    title: 'Kakobuy vs CSSBuy, Superbuy – Porównanie',
    desc: 'Szczegółowe zestawienie wszystkich popularnych arkuszy zakupowych.',
    path: '/artykul/kakobuy-spreadsheet-vs-inne-porownanie',
    img: 'https://readdy.ai/api/search-image?query=Comparison%20concept%20flat%20lay%20with%20two%20groups%20of%20similar%20fashion%20products%20arranged%20on%20opposite%20sides%20of%20clean%20white%20table%20subtle%20central%20dividing%20line%20soft%20even%20studio%20lighting%20balanced%20symmetrical%20composition%20minimal%20aesthetic%20professional%20ecommerce%20photography%20with%20pastel%20accent%20details%20and%20precise%20spacing&width=600&height=400&seq=home-article-card-05&orientation=landscape',
    seq: 'home-art-5',
  },
];

export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Kakobuy Spreadsheet Polska',
    url: 'https://kakobuyfinds.yachts',
    description:
      'Największy Kakobuy Spreadsheet w Polsce – tysiące starannie wybranych produktów, codziennie aktualizowane linki i poradniki zakupowe.',
    inLanguage: 'pl',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20lay%20composition%20featuring%20an%20artistic%20arrangement%20of%20premium%20sneakers%20designer%20accessories%20leather%20goods%20and%20fashion%20items%20on%20textured%20white%20marble%20and%20linen%20surfaces%20soft%20diffused%20natural%20daylight%20from%20large%20windows%20warm%20ivory%20beige%20and%20terracotta%20color%20palette%20sophisticated%20contemporary%20aesthetic%20with%20gentle%20shadows%20and%20elegant%20minimal%20styling%20high%20end%20fashion%20photography&width=1200&height=630&seq=kakobuy-og-image&orientation=landscape',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Kakobuy Spreadsheet Polska',
    url: 'https://kakobuyfinds.yachts',
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
    description: 'Największy Kakobuy Spreadsheet w Polsce – tysiące starannie wybranych produktów, codziennie aktualizowane linki i poradniki zakupowe.',
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />

      {/* Mobile Sticky Top Bar */}
      <div className="md:hidden sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="flex items-center justify-between px-4 py-3">
          <Link to="/" className="font-heading text-base font-bold text-foreground-900">
            Kakobuy Spreadsheet
          </Link>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200 text-foreground-700 cursor-pointer"
            aria-label="Menu"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-lg`}></i>
          </button>
        </div>

        {/* Mobile Slide-out Menu */}
        {mobileMenuOpen && (
          <div className="border-t border-background-200 bg-background-50 animate-in slide-in-from-top">
            <div className="px-4 py-3 space-y-1 max-h-[60vh] overflow-y-auto">
              <p className="text-xs text-foreground-400 uppercase tracking-wider px-2 py-1 font-medium">
                Artykuły Kakobuy Spreadsheet
              </p>
              {latestArticles.map((a) => (
                <Link
                  key={a.path}
                  to={a.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className="flex items-center gap-2.5 px-2 py-2 rounded-lg text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
                >
                  <i className="ri-article-line text-primary-500 text-sm"></i>
                  {a.title}
                </Link>
              ))}
              <div className="border-t border-background-200 my-2"></div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-2.5 px-2 py-2.5 rounded-lg text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 transition-colors"
              >
                <i className="ri-file-list-3-line"></i>
                Kakobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-2.5 px-2 py-2.5 rounded-lg text-sm font-semibold text-white bg-accent-500 hover:bg-accent-600 transition-colors"
              >
                <i className="ri-shopping-cart-2-line"></i>
                Buy It Now
              </a>
            </div>
          </div>
        )}
      </div>

      <HeroSection />
      <CategorySection />

      {/* SEO Content Section */}
      <section className="w-full bg-background-50 py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="bg-background-100 border border-background-200 rounded-2xl p-8 md:p-12">
            <article>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                Kakobuy Spreadsheet – Twój Klucz do Najlepszych Produktów w 2026
              </h2>

              <p className="text-foreground-700 leading-relaxed mb-4">
                W świecie zakupów online, <strong>Kakobuy Spreadsheet</strong> stał się
                nieodzownym narzędziem dla każdego, kto szuka wysokiej jakości produktów w
                atrakcyjnych cenach. Nasz <strong>Kakobuy Spreadsheet</strong> to nie tylko zwykła
                lista linków – to kompleksowy przewodnik zakupowy, który codziennie pomaga setkom
                użytkowników z Polski i Europy odnaleźć dokładnie to, czego szukają. Niezależnie od
                tego, czy interesują Cię buty, odzież, akcesoria czy perfumy –{' '}
                <strong>Kakobuy Spreadsheet</strong> ma wszystko, czego potrzebujesz.
              </p>

              <p className="text-foreground-700 leading-relaxed mb-4">
                Dlaczego <strong>Kakobuy Spreadsheet Polska</strong> cieszy się tak dużym
                zainteresowaniem? Przede wszystkim ze względu na regularne aktualizacje. Każdego
                dnia nasz zespół przeszukuje dziesiątki platform, aby dodać nowe, sprawdzone linki
                do arkusza. Dzięki temu użytkownicy <strong>Kakobuy Spreadsheet</strong> zawsze mają
                dostęp do najświeższych ofert – od limitowanych edycji Nike i Jordan po ekskluzywne
                akcesoria i perfumy.
              </p>

              <h3 className="text-xl font-heading font-semibold text-foreground-900 mt-8 mb-4">
                Najlepszy Kakobuy Spreadsheet dla Polaków
              </h3>

              <p className="text-foreground-700 leading-relaxed mb-4">
                Jeśli szukasz <strong>Best Kakobuy Spreadsheet</strong> dostosowanego do potrzeb
                polskich użytkowników, trafiłeś w idealne miejsce. Nasz arkusz jest zoptymalizowany
                pod kątem wysyłki do Polski, a wszystkie kategorie – od{' '}
                <strong>Kakobuy Shoes Spreadsheet</strong> po{' '}
                <strong>Kakobuy Clothing Spreadsheet</strong> – są regularnie przeglądane i
                aktualizowane. W przeciwieństwie do innych arkuszy, nasz{' '}
                <strong>Kakobuy Spreadsheet</strong> oferuje przejrzysty podział na 14 kategorii,
                które ułatwiają nawigację i szybkie znalezienie interesujących produktów.
              </p>

              <h3 className="text-xl font-heading font-semibold text-foreground-900 mt-8 mb-4">
                Kakobuy Spreadsheet vs Inne Arkusze – Porównanie
              </h3>

              <p className="text-foreground-700 leading-relaxed mb-6">
                Na rynku dostępnych jest wiele arkuszy zakupowych, ale{' '}
                <strong>Kakobuy Spreadsheet</strong> wyróżnia się na tle konkurencji. Poniżej
                przedstawiamy porównanie naszego arkusza z popularnymi alternatywami:
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                {comparisonItems.map((item, i) => (
                  <div
                    key={i}
                    className="bg-background-50 border border-background-200 rounded-xl p-5"
                  >
                    <p className="text-sm font-semibold text-foreground-900 mb-1">
                      {item.name} vs {item.vs}
                    </p>
                    <p className="text-xs text-foreground-600">
                      <span className="text-primary-500 font-medium">Przewaga Kakobuy:</span>{' '}
                      {item.advantage}
                    </p>
                  </div>
                ))}
              </div>

              <p className="text-foreground-700 leading-relaxed mb-4">
                W porównaniu do <strong>CSSBuy Spreadsheet</strong>,{' '}
                <strong>Superbuy Spreadsheet</strong> czy <strong>Sugargoo Spreadsheet</strong>,
                nasz <strong>Kakobuy Spreadsheet</strong> oferuje nie tylko większą liczbę
                produktów, ale także bardziej intuicyjny podział na kategorie oraz dedykowane
                wsparcie dla użytkowników z Polski. To sprawia, że jest to{' '}
                <strong>Best Kakobuy Spreadsheet Polska</strong> dostępny obecnie na rynku.
              </p>

              <p className="text-foreground-700 leading-relaxed mb-6">
                Niezależnie od tego, czy jesteś doświadczonym użytkownikiem agentów zakupowych, czy
                dopiero zaczynasz swoją przygodę z zakupami przez Kakobuy – nasz{' '}
                <strong>Kakobuy Spreadsheet</strong> został zaprojektowany tak, aby każdy mógł z
                niego łatwo korzystać. Od <strong>Kakobuy Finds</strong> po zaawansowane
                wyszukiwanie – wszystko znajdziesz w jednym miejscu.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-4 mt-8">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/20 hover:-translate-y-0.5"
                >
                  <i className="ri-file-list-3-line"></i>
                  Przeglądaj Kakobuy Spreadsheet
                </a>
                <Link
                  to="/artykul/kakobuy-spreadsheet-poradnik-2026"
                  className="inline-flex items-center gap-2 bg-background-200 hover:bg-background-300 text-foreground-800 font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap hover:-translate-y-0.5"
                >
                  <i className="ri-article-line"></i>
                  Przeczytaj Pełny Poradnik
                </Link>
              </div>
            </article>
          </div>
        </div>
      </section>

      <WhySection />

      {/* Latest Articles Section */}
      <section className="w-full bg-background-100 py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 md:px-10">
          <div className="text-center mb-12">
            <p className="text-accent-500 text-sm tracking-widest uppercase mb-3 font-medium">
              Baza wiedzy
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
              Najnowsze Artykuły o <span className="text-primary-500">Kakobuy Spreadsheet</span>
            </h2>
            <p className="text-foreground-600 text-base max-w-2xl mx-auto">
              Pogłębiaj swoją wiedzę o zakupach przez Kakobuy. Sprawdź nasze poradniki, porównania i przewodniki.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.path}
                to={article.path}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="relative w-full h-44 overflow-hidden">
                  <img
                    src={article.img}
                    alt={article.title}
                    className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium mt-3">
                    Czytaj więcej
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/artykul/kakobuy-spreadsheet-poradnik-2026"
              className="inline-flex items-center gap-2 bg-background-200 hover:bg-background-300 text-foreground-800 font-semibold px-6 py-3 rounded-lg transition-all duration-300 whitespace-nowrap text-sm"
            >
              <i className="ri-book-open-line"></i>
              Zobacz Wszystkie Artykuły
            </Link>
          </div>
        </div>
      </section>

      {/* Article CTA Banner */}
      <section className="w-full bg-background-50 py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-10">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Luxurious%20editorial%20fashion%20flat%20lay%20with%20assorted%20designer%20sneakers%20premium%20leather%20handbags%20silk%20scarves%20and%20gold%20toned%20accessories%20artfully%20arranged%20on%20cream%20linen%20fabric%20surface%20soft%20directional%20window%20light%20casting%20elegant%20shadows%20refined%20palette%20of%20ivory%20taupe%20blush%20and%20champagne%20tones%20high%20end%20product%20photography%20with%20sophisticated%20styling&width=1200&height=500&seq=kakobuy-home-cta-x7&orientation=landscape"
              alt="Kakobuy Spreadsheet – produkty premium"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
            <div className="relative z-10 p-8 md:p-12">
              <p className="text-accent-300 text-sm tracking-widest uppercase mb-3 font-medium">
                Najnowszy artykuł
              </p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4 max-w-lg">
                Kompletny Poradnik Kakobuy Spreadsheet 2026 – Wszystko, Co Musisz Wiedzieć
              </h2>
              <p className="text-white/70 text-sm md:text-base mb-6 max-w-md leading-relaxed">
                Dowiedz się, jak efektywnie korzystać z Kakobuy Spreadsheet, poznaj najlepsze
                kategorie produktów, triki zakupowe i sprawdzone strategie oszczędzania na
                wysyłce do Polski.
              </p>
              <Link
                to="/artykul/kakobuy-spreadsheet-poradnik-2026"
                className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap hover:-translate-y-0.5"
              >
                <i className="ri-arrow-right-line"></i>
                Czytaj Poradnik
              </Link>
            </div>
          </div>
        </div>
      </section>

      <HowItWorks />

      {/* Shipping & QC Section */}
      <section className="w-full bg-background-50 py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-background-100 border border-background-200 rounded-2xl p-8">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 mb-4">
                <i className="ri-ship-line text-lg"></i>
              </span>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                Wysyłka Kakobuy Spreadsheet – Polska
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                Wszystkie produkty z naszego <strong>Kakobuy Spreadsheet</strong> można zamówić z
                dostawą do Polski. Oferujemy wsparcie w wyborze najlepszej metody wysyłki – od
                ekonomicznych linii pocztowych po ekspresowe przesyłki kurierskie. Nasz{' '}
                <strong>Kakobuy Spreadsheet</strong> zawiera również wskazówki dotyczące
                deklaracji celnej i optymalizacji kosztów wysyłki.
              </p>
              <Link
                to="/artykul/wysylka-kakobuy-spreadsheet-polska"
                className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
              >
                Przeczytaj pełny poradnik wysyłki
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>

            <div className="bg-background-100 border border-background-200 rounded-2xl p-8">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4">
                <i className="ri-zoom-in-line text-lg"></i>
              </span>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                Kontrola Jakości (QC) w Kakobuy Spreadsheet
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                Każdy link w naszym <strong>Kakobuy Spreadsheet</strong> przechodzi weryfikację
                jakości. Oznacza to, że znajdziesz tylko produkty od sprawdzonych sprzedawców z
                pozytywnymi opiniami. Dodatkowo nasz <strong>Kakobuy Spreadsheet</strong> zawiera
                porady, jak samodzielnie ocenić jakość produktu przed zakupem.
              </p>
              <Link
                to="/artykul/kakobuy-spreadsheet-vs-inne-porownanie"
                className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
              >
                Zobacz porównanie arkuszy
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <FAQSection />

      {/* Final CTA */}
      <section className="w-full bg-background-50 py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            Gotowy, aby Odkryć <span className="text-primary-500">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 text-base mb-8 max-w-xl mx-auto">
            Dołącz do tysięcy zadowolonych użytkowników i zacznij znajdować najlepsze produkty w
            najlepszych cenach. Kliknij poniżej i przeglądaj nasz Kakobuy Spreadsheet już teraz!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/20 hover:-translate-y-0.5"
            >
              <i className="ri-file-list-3-line"></i>
              Kakobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-all duration-300 whitespace-nowrap shadow-lg shadow-accent-500/20 hover:-translate-y-0.5"
            >
              <i className="ri-shopping-cart-2-line"></i>
              Buy It Now
            </a>
          </div>
        </div>
      </section>

      {/* Mobile Sticky Bottom CTA Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-t border-background-200 px-4 py-3 flex items-center gap-3">
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="flex-1 inline-flex items-center justify-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-4 py-2.5 rounded-lg transition-all duration-300 whitespace-nowrap text-xs"
        >
          <i className="ri-file-list-3-line"></i>
          Kakobuy Sheet
        </a>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="flex-1 inline-flex items-center justify-center gap-1.5 bg-accent-500 hover:bg-accent-600 text-white font-semibold px-4 py-2.5 rounded-lg transition-all duration-300 whitespace-nowrap text-xs"
        >
          <i className="ri-shopping-cart-2-line"></i>
          Buy It Now
        </a>
      </div>

      {/* Bottom padding for mobile sticky bar */}
      <div className="md:hidden h-16"></div>

      <Footer />
    </div>
  );
}